import { createContext, useContext, useState, useCallback } from "react";

const AssistantContext = createContext(null);

export function AssistantProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [agent, setAgent] = useState("guide");

  const openWith = useCallback((agentId) => {
    if (agentId) setAgent(agentId);
    setIsOpen(true);
  }, []);
  const toggle = useCallback(() => setIsOpen((v) => !v), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <AssistantContext.Provider value={{ isOpen, agent, setAgent, openWith, toggle, close }}>
      {children}
    </AssistantContext.Provider>
  );
}

export const useAssistant = () => useContext(AssistantContext);
